import axios from 'axios';
import { encryptSensitiveFields, decryptSensitiveFields } from '../utils/EncryptionUtils';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const createApiInstance = () => {
    const token = localStorage.getItem('token');
    return axios.create({
        baseURL: API_BASE_URL,
        headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        },
    });
};

export interface TopClient {
    clientId: string;
    clientName: string;
    totalRevenue: number;
    invoiceCount: number;
}

export interface MonthlyRevenue {
    year: number;
    month: number;
    revenue: number;
    cashRevenue: number;
}

export interface Statistics {
    // Financial metrics
    todayRevenue: number;
    monthRevenue: number;
    yearRevenue: number;
    yearSpent: number;
    totalSales: number;
    totalPurchases: number;
    pendingPayments: number;
    pendingToBePaid: number;

    // Invoice statistics
    totalInvoices: number;
    sellInvoicesCount: number;
    purchaseInvoicesCount: number;
    averageInvoiceValue: number;

    // Client/Supplier metrics
    totalClients: number;
    totalSuppliers: number;
    newClientsThisMonth: number;
    topClients: TopClient[];

    // Inventory/Stock
    totalProducts: number;
    lowStockProductsCount: number;
    totalStockValue: number;

    // Order statistics
    reservationOrdersCount: number;
    confirmedOrdersCount: number;
    completedOrdersCount: number;
    cancelledOrdersCount: number;

    // Revenue trends
    revenueByMonth: MonthlyRevenue[];
}

const statisticsAPI = {
    getStatistics: async (companyId: string): Promise<Statistics> => {
        const api = createApiInstance();
        const response = await api.get<Statistics>(`/statistics/${companyId}`);
        response.data.topClients = decryptSensitiveFields( new Set(["clientName"]), response.data.topClients) as TopClient[];
        return response.data as Statistics;
    }
};

export default statisticsAPI;
